export const APPLEPAY_SESSION_ENDPOINT = 'v1/applePay/sessions';
